import z from 'zod';
import {questionSchema} from '../../question/questionSchema';

export const sessionQuestionSchema = questionSchema.extend({
  /** The answer selected by the user. undefined means not answered yet. */
  selectedAnswer: z.string().optional(),
  /** Whether the answer was correct. undefined means not answered yet. */
  isCorrect: z.boolean().optional(),
});

export type SessionQuestion = z.infer<typeof sessionQuestionSchema>;
